import styled from 'styled-components/macro';

export const Container = styled.div`

`;

export const HeadingLabel = styled.div`
  font-size: 14px;
  color: ${(props) => props.theme.palette.black[50]};
  font-weight: ${({ theme }) => theme.typography.weight.semiBold};
`;

export const HeadingItem = styled.div`
  font-size: 18px;
  font-weight: ${({ theme }) => theme.typography.weight.semiBold};
  min-height: 25px; 
`;
